import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import { TAppDispatch } from '@/store/configuration';
import { TAppState } from '@/store/reducers/reducers';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => TAppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<TAppState> = useSelector;
